export default __webpack_public_path__ + "static/media/Butt_Pain.0aecdbb2.png";